import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import appointmentsActions from '../features/appointments/actions'
import dialogActions from '../features/dialog/actions'
import { pxToRem } from '../libs/style'
import { getAppointmentIdFromUrl } from '../libs/url'
import { useTeloRouter } from '../routing/teloRouter'
import { useTeloDispatch } from '../store'
import Button from '../styleguide/buttons/Button'
import DialogActions from '../styleguide/dialog/DialogActions'
import DialogContent from '../styleguide/dialog/DialogContent'
import DialogContentText from '../styleguide/dialog/DialogContentText'

const DialogContentTextStyled = styled(DialogContentText)`
	min-width: ${pxToRem(299)}rem;
`

const DeleteAppointmentDialog = () => {
	const { t } = useTranslation()
	const dispatch = useTeloDispatch()
	const { navigate } = useTeloRouter()

	return (
		<>
			<DialogContent>
				<DialogContentTextStyled>
					{t('appointment.deleteQuestion')}
				</DialogContentTextStyled>
			</DialogContent>
			<DialogActions>
				<Button
					onClick={() => dispatch(dialogActions.closeDialog())}
					variant="outlined"
				>
					{t('app.cancel')}
				</Button>
				<Button
					onClick={() => {
						const appId = getAppointmentIdFromUrl() || ''
						dispatch(
							appointmentsActions.deleteAppointmentAction(appId, navigate),
						)
						dispatch(dialogActions.closeDialog())
					}}
					autoFocus
					variant="contained"
				>
					{t('appointment.yesDelete')}
				</Button>
			</DialogActions>
		</>
	)
}

export default DeleteAppointmentDialog
